import { gql } from '@apollo/client';
export const PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS = gql `
  fragment PendingDocumentRequestIdListFields on DocumentRequestDto {
    id
    status
    relatedId
    relatedObjectTypeId
    consideredId
    consideredObjectTypeId
    documentalGroupId
    documentTypeId
  }
`;
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const DOCUMENTAL_VALIDATION_STATISTICS_FIELDS = gql `
  fragment DocumentalValidationStatisticsFields on DocumentalValidationStatisticsDto {
    lastEvaluationDate
    documentsPresentInDocumentalGroups
    validationResult
    techinalValidationResultMap
    numNoValidationDocs
    numInvalidatedDocs
    actualInvalidatedDocsUsedInDocumentalGrops
    numValidatedDocs
    validationsNeededInDocumentalGroups
    technicalValidationsPresentInDocumentalGroups
    documentsNeededInDocumentalGroups
    technicalValidationsNeededInDocumentalGroups
    typologyAndDocuments
    validationsPresentInDocumentalGroups
    typologyResultMap
  }
`;
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const DOCUMENTAL_VALIDATION_LINE_FIELDS = gql `
  ${PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS}
  fragment DocumentalValidationLineFields on DocumentalValidationLineDto {
    ignored
    quantity
    documentTypeId
    documentTypeCode
    documentTypeFormatList
    id
    documentTypeName
    status
    pendingDocumentRequestIdList {
      ...PendingDocumentRequestIdListFields
    }
  }
`;
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const DOCUMENTAL_VALIDATION_FIELDS = gql `
  ${DOCUMENTAL_VALIDATION_LINE_FIELDS}
  ${DOCUMENTAL_VALIDATION_STATISTICS_FIELDS}
  ${PENDING_DOCUMENT_REQUEST_ID_LIST_FIELDS}
  fragment DocumentalValidationFields on DocumentalValidationDto {
    id
    documentalGroupName
    consideredId
    consideredObjectTypeId
    relatedObjectTypeId
    relatedId
    personalization
    validation
    groupValidation
    pendingDocumentRequestIdList {
      ...PendingDocumentRequestIdListFields
    }
    documentalGroupCode
    documentalGroupId
    documentalValidationLines {
      ...DocumentalValidationLineFields
    }
    evaluationResults {
      ...DocumentalValidationStatisticsFields
    }
  }
`;
